import {Injectable} from '@angular/core';
import {ConfigurationService} from './configuration.service';
import {SysConfigModel} from '../models/sys-config.model';

@Injectable({
    providedIn: 'root'
})
export class FindSystemConfigService {

    constructor(private configService: ConfigurationService) {
    }

    findSystemSettingByNumber(num: number) {
      const systemConfiguration = this.configService.getSystemConfiguration();
      let resultConfig = systemConfiguration.find(elem => {
          return elem.num === num;
      });
      if (!resultConfig) {
          resultConfig = new SysConfigModel();
      }
      return resultConfig;
    }
}
